module.exports = __webpack_public_path__ + "static/media/Number3.a6a7e016.svg";